// ⏳ Live event countdown — pill for the map + reusable ticking Countdown.
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmt = (ms) => {
  if (ms <= 0) return "ending…";
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms % 86400000) / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  return d > 0 ? `${d}d ${h}h ${m}m` : h > 0 ? `${h}h ${m}m ${s}s` : `${m}m ${s}s`;
};

export const Countdown = ({ ends, className = "" }) => {
  const [left, setLeft] = useState(() => new Date(ends) - Date.now());
  useEffect(() => {
    const t = setInterval(() => setLeft(new Date(ends) - Date.now()), 1000);
    return () => clearInterval(t);
  }, [ends]);
  return <span className={className} data-testid="event-countdown">{fmt(left)}</span>;
};

export const EventCountdownPill = () => {
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  useEffect(() => { axios.get(`${API}/event`).then((r) => { if (r.data.active) setEvent(r.data); }).catch(() => {}); }, []);
  if (!event) return null;
  return (
    <button
      data-testid="map-event-pill"
      onClick={() => navigate("/collect")}
      title={event.blurb}
      className="shrink-0 pointer-events-auto flex items-center gap-1.5 rounded-full pl-2.5 pr-3 py-1.5 shadow-lg shadow-fuchsia-500/30 bg-gradient-to-r from-fuchsia-600 to-violet-600 text-white text-[11px] font-heading font-black whitespace-nowrap active:scale-95 transition-transform"
    >
      <span>{event.emoji}</span> {event.label}
      <span className="bg-white/20 rounded-full px-2 py-0.5">⏳ <Countdown ends={event.ends} /></span>
    </button>
  );
};
